import { QueryClient } from "@tanstack/react-query"
import { getVcMatchesQuery } from "@/feature/fundraising-advisory/vc-matching/api/index.ts"
import { DEFAULT_QUERY_ARGS } from "@/feature/fundraising-advisory/vc-matching/constants.ts"

export const getVcMatchingLoader = (queryClient: QueryClient) => async () => {
  const vcMatches = queryClient.ensureQueryData(
    getVcMatchesQuery({
      ...DEFAULT_QUERY_ARGS,
    })
  )

  return {
    vcMatches,
  }
}
